<template>
    <v-expansion-panel-content
            expand-icon="mdi-menu-down"
    >
        <template v-slot:header>

            <v-list-item
                    avatar
            >

                <v-list-item-avatar>
                    <img :src="avatar">
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>
                        <div class="d-inline-flex">
                            <v-rating
                                    :value="stars"
                                      background-color="secondary"
                                      color="accent"
                                      dense
                                      size="20"
                                      readonly></v-rating>
                            <span class="comment-stars-count">({{rating.stars}})</span>
                        </div>
                    </v-list-item-title>
                    <div class="author-label">
                        <span>{{userName}}</span>
                        <span class="ml-1 comment-date-moment">{{date}}</span>
                    </div>
                </v-list-item-content>

            </v-list-item>

        </template>

        <v-sheet height="60" class="pa-4 mb-1 text-left comment">
            <div class="text-truncate">
                {{rating.comment}}
            </div>
        </v-sheet>

        <v-flex xs12 text-right pr-3 pb-2>
            <span class="grey--text" v-if="rating.replies_count">
                {{rating.replies_count}} respuesta{{rating.replies_count > 1 ? 's' : ''}}
            </span>
            <v-btn
                    small
                    text
                    color="primary"
                    :to="`/providers/ratings/${rating.id}`"
            >Ver calificación</v-btn>

        </v-flex>


    </v-expansion-panel-content>



</template>
<script>

    import UserCardCompact from '@/components/users/UserCardCompact'
    import {getFakeAvatar} from '@/utils/Common'

    export default{
        props: ['rating'],
        components: {
            UserCardCompact
        },
        data(){
          return {
              stars: this.rating.stars
          }
        },
        computed:{
            avatar(){

                var vm = this
                return vm.rating.author.avatar || getFakeAvatar(vm.rating.author.gender)

            },
            date(){
                var vm = this
                return vm.$moment(vm.rating.created_at).fromNow()
            },
            userName(){
                var vm = this
                return (vm.rating.author.user_name || `${vm.rating.author.first_name} ${vm.rating.author.last_name[0]}.`)
            }
        }
    }
</script>
<style scoped>

    >>>.v-list__tile--avatar{
        height: 66px
    }

    .auhor-label{
        max-width: 100px !important;
    }

    .comment-date-moment{
        color: #989898;
        font-size: .9em;
    }

    .comment-stars-count{
        color: #989898;
    }

    .comment{
        width: 100%;
    }
</style>
